/**
 * Maps element keys to their display names
 * @param element The element key
 * @returns The display name for the element
 */
export const getElementDisplayName = (element: string): string => {
  // Map of special element keys to their display names
  const elementDisplayMap: Record<string, string> = {
    label: 'Name',
    name: 'Key',
    form_field_type: 'Field Type',
    // Add more mappings as needed
  }

  // Return the mapped name or use titleCase for other elements
  return elementDisplayMap[element] || element
}
